
  export default {
    name: 'NotAutorizedView'
  }
